import { deleteCookie, readCookie } from '../state/cookies'
import { clearDraft } from './storage'

/**
 * The shop's word that a checkout completed.
 *
 * The draft survives the handoff on purpose, so Back restores the form for a
 * visitor who changed their mind — but a visitor who bought would otherwise
 * carry a cart badge around the site until the tab closed, since nothing on
 * Shopify's side can reach this origin's storage. A custom pixel on the shop
 * can set a cookie, though, and a cookie on `.codeverse.com` is readable
 * here. The pixel sets this one on `checkout_completed` (the README has it);
 * the bundle consumes it once, ending the draft it was written to survive.
 */
export const PURCHASED_COOKIE = 'cv_purchased'

/**
 * Consume the signal: true once per purchase, at which point the cookie is
 * dropped along with the draft, so a later look starts clean.
 */
export function consumePurchase(): boolean {
  if (readCookie(PURCHASED_COOKIE) === null) return false
  deleteCookie(PURCHASED_COOKIE)
  clearDraft()
  return true
}
